// JS for product item add to cart. Added by HG from InsCoder [19 Aug 2021]
(function(){

  const $addToCartBtns = document.querySelectorAll('.js-product-item__cta');


  function addToCart(event, varId) {
    event.preventDefault();

    var $thisBtn = event.target;
    $thisBtn.classList.add('loading');

    let addData = {
      'id':varId,
      'quantity':1
    };

    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(addData),
    })
    .then(response => {
      $thisBtn.classList.remove('loading');

      // Update SubTotal
      fetch('/cart.js').then(function (response) {
        // The API call was successful!
        return response.json();
      }).then(function (data) {
        // This is the JSON from our response
        // console.log('data', data)
        const dataItems = data.items.map(item => `${item.id}:${item.quantity}`);
        document.querySelector('[data-buy-now-button]').setAttribute('href', `/cart/${dataItems}`);
        document.querySelector('[data-subtotal]').innerHTML = Shopify.formatMoney(data.total_price, themeVariable.moneyFormat).replace(/\"/g,'');

        // prepare item in cart drawer
        const selectedTarts = data.items.map(item => {
          const tartQty = item.quantity;
          const tartID = item.id;
          const tartImg = item.image;
          const tartUrl = item.url;
          const tartTitle = item.title;
          const tartPrice = item.price;
          return `
            <div class="quick-cart__item ff-body fs-body-base" data-id="${ tartID }" data-quantity="${ tartQty }">
              <div class="quick-cart__item-left">
                <a href="/products/sesame-matcha-tarte?variant=${ tartID }">
                  <div class="quick-cart__image"><img class="image__img ls-is-cached lazyloaded" alt="${ tartTitle }"
                    data-src="${ tartImg }"
                    src="${ tartImg }">
                  </div>
                </a>
              </div>
              <div class="quick-cart__item-middle">
                <h4 class="fs-body-bold"><a href="${ tartUrl }">${ tartTitle }</a></h4>
                <div>
                  ${ Shopify.formatMoney(tartPrice, themeVariable.moneyFormat).replace(/\"/g,'') }
                  <span class="c-subdued">x ${ tartQty }</span>
                </div>
              </div>
              <div class="quick-cart__control">
                <div class="quick-cart__control-top">
                  <button class="quick-cart__button quick-cart__button-increase" data-increase="${ tartID }" aria-label="Subtract product quantity">
                    <div class="icon">
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                        <path fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" d="M12 5v14M5 12h14"></path>
                      </svg>
                    </div>
                  </button>
                  <button class="quick-cart__button quick-cart__button-decrease" data-decrease="${ tartID }" aria-label="Add product quantity">
                    <div class="icon">
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                        <path fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" d="M5 12h14"></path>
                      </svg>
                    </div>
                  </button>
                  <button class="quick-cart__button quick-cart__button-remove" data-remove="${ tartID }" aria-label="Remove">
                    <div class="icon">
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                        <path fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" d="M3 6h18M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                      </svg>
                    </div>
                  </button>
                </div>
              </div>
            </div>
            `
        }).join('');

        // display selected items in cart drawer
        document.querySelector('.quick-cart__items').innerHTML = selectedTarts;

        // show cart drawer
        // if(buttonType != 'buy_now') {
          document.querySelector('[data-js-cart-icon]').click();
          document.querySelector('.quick_cart__empty').classList.remove('visible');
          document.querySelector('.quick-cart__footer').classList.add('visible');
        // }

        // update cart count in header
        document.querySelectorAll('[data-js-cart-count]').forEach(cartCount => cartCount.innerHTML = data.item_count);

      }).catch(function (err) {
        // There was an error
        console.warn('Something went wrong.', err);
      });

    })
    .catch((error) => {
      console.error('Error:', error);
    });
  }

  $addToCartBtns.forEach(function(prodItem) {
    var varId = prodItem.getAttribute('data-variant-id');
    prodItem.addEventListener('click', event => addToCart(event, varId));
  });


})();